/* eslint-disable */
import {
  Avatar,
  createStyles,
  IconButton,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Theme,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { connectModal, show } from "redux-modal";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import Image from "./../../assets/img/search-solid.svg";
import CancelIcon from "@material-ui/icons/Cancel";
import { DeleteIcon } from "@chakra-ui/icons";
import {
  getAllIssuerSigners,
  getAllProductSigners,
  deleteIssuerSigner,
  deleteProductSigner,
} from "../../utils/store/actions/funds.actions";

const styles = (theme: Theme) =>
  createStyles({
    searchList: {
      backgroundImage: `url(${Image}
    )` /* Add a search icon to input */,
      backgroundSize: "16px",
      backgroundPosition: "12px 12px" /* Position the search icon */,
      backgroundRepeat: "no-repeat" /* Do not repeat the icon image */,
      fontSize: "16px" /* Increase font-size */,
      padding: "12px 20px 12px 40px" /* Add some padding */,
      marginBottom: "10px",
      border: "1px solid #97A0C3",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      borderRadius: "10px",
      color: "#97A0C3",
    },
    avatar: { background: "#242F57" },
    paper: {
      background: "#FFFFFF",
      border: "1px solid #EAEDF7",
      // boxSizing: "border-box",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      borderRadius: "12px",
      marginBottom: "12px",
      // height: "64px",
      display: "flex",
    },
    createSigners: {
      alignItems: "center",
      justifyContent: "center",
      marginTop: "2%",
      right: "-2vh",
      float: "right",
      paddingBottom: "-2vh",
    },
    buttonSigners: {
      marginTop: "-8vh",
      color: "white",
      width: "100%",
      backgroundColor: "#ae0064",
    },
    listItem: {
      border: "1px solid #EAEDF7",
      borderRadius: "12px",
      marginBottom: "10px",
      boxShadow: "0px 2px 4px rgba(28, 41, 90, 0.0367952)",
      "&:hover": {
        cursor: "pointer",
        background: "#F5F6FF",
      },
    },
  });

class ModalSigners extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      inputValue: "",
    };
  }
  handleSearch(e: any) {
    this.setState({ inputValue: e.target.value });
  }
  handleDelete(signerId: string) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const fundPersonId = urlParams.get("id");
    (this.props.signerType === "ISSUER"
      ? this.props.deleteIssuerSigner(signerId, fundPersonId)
      : this.props.deleteProductSigner(signerId, fundPersonId)
    ).then(() => {
      this.props.signerType === "ISSUER"
        ? this.props.getAllIssuerSigners(fundPersonId)
        : this.props.getAllProductSigners(fundPersonId);
    });
  }
  render() {
    const { show, handleHide, t, classes } = this.props;
    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <Modal
        isOpen={show}
        toggle={handleHide}
        backdrop={true}
        style={{
          backgroundColor: "#f5f6ff",
          top: "20%",
          maxWidth: "80%",
          width: "80%",
        }}
      >
        <ModalHeader
          toggle={handleHide}
          close={closeBtn}
          style={{
            backgroundColor: "#f5f6ff",
            color: "black",
            fontWeight: "bolder",
            fontSize: "15px",
          }}
        >
          {this.props.signerType === "ISSUER"
            ? t("ISSUER")
            : t("PRODUCT_SIGNER")}
        </ModalHeader>
        <ModalBody
          style={{
            backgroundColor: "#f5f6ff",
          }}
        >
          <Paper style={{ background: "none", boxShadow: "none" }}>
            <input
              style={{ width: "-webkit-fill-available" }}
              type="text"
              className={classes.searchList}
              id="myInput"
              value={this.state.inputValue}
              onChange={(e: any) => this.handleSearch(e)}
              placeholder={t("SEARCH")}
            />
          </Paper>
          {this.props.Funds ? (
            (this.props.signerType === "ISSUER"
              ? this.props.Funds.issuer_fund_signers_list
              : this.props.Funds.product_fund_signers_list
            )
              .filter(
                (obj: any) =>
                  obj.name
                    .toLowerCase()
                    .includes(this.state.inputValue.toLowerCase()) ||
                  obj.firstName
                    .toLowerCase()
                    .includes(this.state.inputValue.toLowerCase())
              )
              .map((signer: any) => {
                return (
                  <>
                    <Paper
                      className={classes.paper}
                      onClick={() =>
                        this.setState({
                          modalOpen: true,
                          modal: signer.id,
                        })
                      }
                      key={signer.id}
                    >
                      <ListItem
                        onClick={() => {
                          this.props.showModal("create_update_signer", {
                            name: "create_update_signer",
                            history,
                            signer: signer,
                            enums: this.props.Surveys.enums,
                            signerType: this.props.signerType,
                            actionDone: "UPDATE",
                          });
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar className={classes.avatar}>
                            {signer.name[0].toUpperCase()}
                            {signer.firstName &&
                              signer.firstName[0].toUpperCase()}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              style={{
                                color: "#010028",
                                fontWeight: 500,
                                fontSize: "14px",
                              }}
                            >
                              {signer.firstName
                                ? signer.firstName?.length +
                                    signer.name.length >
                                  60
                                  ? signer.name.length < 60
                                    ? `${signer.firstName[0]}. ${signer.name}`
                                    : `${
                                        signer.firstName[0]
                                      }. ${signer.name.slice(0, 60)}...`
                                  : `${signer.firstName} ${signer.name}`
                                : signer.name.length < 60
                                ? `${signer.name}`
                                : `${signer.name.slice(0, 60)}...`}
                            </Typography>
                          }
                        />
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleDelete(signer.id);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ListItem>
                    </Paper>
                  </>
                );
              })
          ) : (
            <div>{this.props.t("NO_CONTACTS")}</div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}
const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  showModal: show,
  deleteIssuerSigner,
  deleteProductSigner,
  getAllIssuerSigners,
  getAllProductSigners,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withStyles(styles)(connectModal({ name: "signers_modal" })(ModalSigners))
  )
);
